import { featureFlagKeys } from 'modules/common/drawers/featureFlagDrawer/const/featureFlagKeys';
import { hasProcessPermission } from 'modules/common/permissions';

import type { RootState } from 'store/configureStore';
import { getFeatureFlagValue } from 'store/session/selectors';

import { RulesListPage } from './RulesListPage';

const isRequirementsReviewEnabled = (state: RootState) =>
  getFeatureFlagValue(state, featureFlagKeys.isRequirementsReviewEnabled);

const routes = [
  {
    component: RulesListPage,
    exact: true,
    name: 'rulesListPage',
    path: '/processes/rules',
    helpId: 'rules_list',
    permissions: [isRequirementsReviewEnabled, hasProcessPermission],
  },
];

export default routes;
